import { createFileRoute, Link } from "@tanstack/react-router";
import Markdown from "react-markdown";
import remarkGfm from "remark-gfm";
import content from "../../REFUND_POLICY.md?raw";
import styles from "./blog/blog.module.css";

export const Route = createFileRoute("/refund")({
  head: () => ({
    meta: [
      { title: "Refund Policy - Site Spy" },
      {
        name: "description",
        content: "Refund Policy for Site Spy subscriptions",
      },
    ],
  }),
  component: RefundPage,
});

function RefundPage() {
  return (
    <main className={styles.main}>
      <div className={styles.bgGradient} />

      <header className={styles.header}>
        <Link to="/" className={styles.backLink}>
          &larr; Site Spy
        </Link>
      </header>

      <article className={styles.article}>
        <div className={styles.content}>
          <Markdown remarkPlugins={[remarkGfm]}>{content}</Markdown>
        </div>
      </article>

      <footer className={styles.footer}>
        <Link to="/">Home</Link>
        <Link to="/blog">Blog</Link>
        <Link to="/pricing">Pricing</Link>
        <Link to="/privacy">Privacy Policy</Link>
        <Link to="/terms">Terms of Service</Link>
        <Link to="/dashboard/support">Support</Link>
      </footer>
    </main>
  );
}
